import { ArrowBack } from "@material-ui/icons";
import React from "react";

import { useStateValue } from "../../config/AppContext";

const BackArrowComponent: React.FC<{
  [x: string]: any;
  show: boolean;
  variant?: string;
  action: () => void;
}> = (props) => {
  const { Methods } = useStateValue();

  if (!props.show || !Methods) return <></>;

  const hanldeClick = () => {
    Methods.handleAbort();
    return props.action();
  };
  return (
    <span className="back-arrow" onClick={hanldeClick}>
      <ArrowBack />
    </span>
  );
};
export default BackArrowComponent;
